export const mainPageBreadcrumbsDict = {
  en: { name: 'Home', item: '/' },
  ru: { name: 'Главная страница', item: '/' },
  de: { name: 'Hauptseite', item: '/' },
  tr: { name: 'Anasayfa', item: '/' },
  es: { name: 'Inicio', item: '/' },
};

export const eventsPageBreadcrumbsDict = {
  en: { name: 'Events', item: '/events/' },
  ru: { name: 'Мероприятия', item: '/events/' },
  de: { name: 'Veranstaltungen', item: '/events/' },
  tr: { name: 'Etkinlikler', item: '/events/' },
  es: { name: 'Eventos', item: '/events/' },
};

export const careersPageBreadcrumbsDict = {
  en: { name: 'Vacancies', item: '/careers/' },
  ru: { name: 'Вакансии', item: '/careers/' },
  de: { name: 'Stellenangebote', item: '/careers/' },
  tr: { name: 'İş İlanları', item: '/careers/' },
  es: { name: 'Vacantes', item: '/careers/' },
};

export const cbiGuidePageBreadcrumbsDict = {
  en: { name: 'CBI guides', item: '/cbi-guide/' },
  ru: { name: 'CBI гайды', item: '/cbi-guide/' },
  de: { name: 'CBI-Führer', item: '/cbi-guide/' },
  tr: { name: 'CBI Rehberleri', item: '/cbi-guide/' },
  es: { name: 'Guías de CBI', item: '/cbi-guide/' },
};

export const workshopsPageBreadcrumbsDict = {
  ru: {
    name: 'Вебинары',
    item: '/workshops',
  },
};

export const videoPageBreadcrumbsDict = {
  ru: {
    name: 'Видео',
    item: '/video',
  },
};
